import React from 'react';

import { IBringgUuids } from '@rbi-ctg/frontend';
import { IServerOrder } from '@rbi-ctg/menu';
import { useStoreContext } from 'state/store';
import { useFlag } from 'utils/launchdarkly';

import useOrderConfirmationMap from './use-order-confirmation-map';

interface IOrderConfirmationMapProps {
  bringgUuids?: IBringgUuids;
  serverOrder: IServerOrder;
}

const Map: React.FC<React.PropsWithChildren<IOrderConfirmationMapProps>> = ({
  bringgUuids = {},
  serverOrder,
}) => {
  const { store } = useStoreContext();

  const enableDeliveryWatchDriverLocation = useFlag(
    'enable-delivery-watch-driver-location'
  );

  const map = useOrderConfirmationMap({
    bringgUuids,
    enableDriverLocation: enableDeliveryWatchDriverLocation,
    serverOrder,
    store,
  });

  return <>{map}</>;
};

export default Map;
